export enum KPI_CODES {
  ACCOUNTS_ACTIVE = "Accounts.Active",
  ACCOUNTS_DEFAULT = "Accounts.Default",
  ACCOUNTS_SEMIACTIVE = "Accounts.Semiactive",
  ACCOUNTS_INACTIVE = "Accounts.Inactive",
  ACCOUNTS_PAYDOFF = "Accounts.PaidOff",
  ACCOUNTS_REPLACED = "Accounts.Replaced",
  ACCOUNTS_CANCELED = "Accounts.Cancelled",
  ACCOUNTS_ARCHIVED = "Accounts.Archived",
  ACCOUNTS_OTHER = "Accounts.Other",
  ACCOUNTS_DRAFT = "Accounts.Draft",

  //Created Items
  PAYMENTS_TODAY = "Payments.CountToday",
  DISBURSEMENTS_TODAY = "Disbursements.CountToday",
  CUSTOMERS_TODAY = "Customers.CountToday",
  CONTRACTS_TODAY = "Contracts.CountToday",
  PAYMENTS_THIS_MONTH = "Payments.CountThisMonth",
  DISBURSEMENTS_THIS_MONTH = "Disbursements.CountThisMonth",
  CUSTOMERS_THIS_MONTH = "Customers.CountThisMonth",
  CONTRACTS_THIS_MONTH = "Contracts.CountThisMonth",
  PAYMENTS_THIS_YEAR = "Payments.CountThisYear",
  DISBURSEMENTS_THIS_YEAR = "Disbursements.CountThisYear",
  CUSTOMERS_THIS_YEAR = "Customers.CountThisYear",
  CONTRACTS_THIS_YEAR = "Contracts.CountThisYear",

  //Restrictions
  ACCOUNTS_PAYMENT_RESTRICTIONS = "Accounts.PaymentsRestrictions",
  ACCOUNTS_DO_NOT_ALLOW = "Accounts.DoNotAllowPaymentsRestrictions",
  ACCOUNTS_NFS_ITEM = "Accounts.NFSItemOutstandingRestrictions",
  ACCOUNTS_ALLOW_IF_ALL_PAST = "Accounts.AllowIfAllPastDueAmountIncludedRestrictions",
  ACCOUNTS_PAYOFF_ONLY = "Accounts.AcceptPayoffOnlyRestrictions",
  ACCOUNTS_ASSIGNMENT_PENDING = "Accounts.AssignmentPendingRestrictions",
  ACCOUNTS_CERTIFIED_FUNDS_ONLY = "Accounts.CertifiedFundsOnlyRestrictions",

  //Account Setup
  ACCOUNTS_BEGINNING_BALANCE = "Accounts.AverageBeginningBalance",
  ACCOUNTS_INTEREST_RATE = "Accounts.AverageInterestRateWithLastTwoDigitsAsFractionPart",
  ACCOUNTS_REGULAR_PAYMENT = "Accounts.AverageRegularAmount",
  ACCOUNTS_WITH_IMPOUNDS = "Accounts.AverageWithImpounds",

  //Customers
  CUSTOMERS_INDIVIDUAL = "Customers.TotalIndividual",
  CUSTOMERS_COMPANY = "Customers.TotalCompany",

  //Impounds
  IMPOUNDS_CLOSED_BALANCE = "Impounds.ClosedAccountsTotalBalanceInThousands",
  IMPOUNDS_TOTAL_BALANCE = "Impounds.AllAccountsTotalBalanceInThousands",

  //Incidents
  INCIDENTS_COUNT_TODAY = "IncidentReports.CountToday",
  INCIDENTS_COUNT_THIS_MONTH = "IncidentReports.CountThisMonth",
  INCIDENTS_COUNT_PREV_MONTH = "IncidentReports.CountPreviousMonth",

  //Payoff Amounts
  PAYOFF_COUNT_TODAY = "Payments.Payoff.CountToday",
  PAYOFF_COUNT_THIS_MONTH = "Payments.Payoff.CountThisMonth",
  PAYOFF_COUNT_THIS_YEAR = "Payments.Payoff.CountThisYear",

  //Mailings
  MAILING_EMAILS_TODAY = "Mailings.Emails.CountToday",
  MAILING_EMAILS_THIS_MONTH = "Mailings.Emails.CountThisMonth",
  MAILING_EMAILS_THIS_YEAR = "Mailings.Emails.CountThisYear",
  MAILING_LETTERS_TODAY = "Mailings.Letters.CountToday",
  MAILING_LETTERS_THIS_MONTH = "Mailings.Letters.CountThisMonth",
  MAILING_LETTERS_THIS_YEAR = "Mailings.Letters.CountThisYear",

  //Conversations
  CHAT_TODAY = "Conversations.Active.CountToday",
  CHAT_THIS_MONTH = "Conversations.Active.CountThisMonth",
  CHAT_THIS_YEAR = "Conversations.Active.CountThisYear",

  //Portal Visits
  VISITS_TODAY = "PortalVisits.CountToday",
  VISITS_THIS_MONTH = "PortalVisits.CountThisMonth",
  VISITS_THIS_YEAR = "PortalVisits.CountThisYear",
  VISITS_FIRST_TIME_TODAY = "PortalVisits.FirstTime.CountToday",
  VISITS_FIRST_TIME_THIS_MONTH = "PortalVisits.FirstTime.CountThisMonth",
  VISITS_FIRST_TIME_THIS_YEAR = "PortalVisits.FirstTime.CountThisYear",

  //Portal visits per device
  MOBILE_TODAY = "PortalVisits.Devices.Mobile.CountToday",
  MOBILE_THIS_MONTH = "PortalVisits.Devices.Mobile.CountThisMonth",
  MOBILE_THIS_YEAR = "PortalVisits.Devices.Mobile.CountThisYear",
  DESKTOP_TODAY = "PortalVisits.Devices.Desktop.CountToday",
  DESKTOP_THIS_MONTH = "PortalVisits.Devices.Desktop.CountThisMonth",
  DESKTOP_THIS_YEAR = "PortalVisits.Devices.Desktop.CountThisYear",

  //Transaction Amounts
  PAYMENTS_AMOUNTS_TODAY = "Payments.Amounts.CountToday",
  PAYMENTS_AMOUNTS_THIS_MONTH = "Payments.Amounts.CountThisMonth",
  PAYMENTS_AMOUNTS_THIS_YEAR = "Payments.Amounts.CountThisYear",
  DISBURSEMENTS_AMOUNTS_TODAY = "Disbursements.Amounts.CountToday",
  DISBURSEMENTS_AMOUNTS_THIS_MONTH = "Disbursements.Amounts.CountThisMonth",
  DISBURSEMENTS_AMOUNTS_THIS_YEAR = "Disbursements.Amounts.CountThisYear",
}
